export default function Debug ({ title, values }) {
  if (process.env.NODE_ENV === 'development') {
    return <div
      style={{
        margin: '3rem 0',
        borderRadius: 4,
        background: '#f6f8fa',
        boxShadow: '0 0 1px  #eee inset',
      }}
    >
      {title}
      <div
        style={{
          fontSize: 11,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          fontWeight: 500,
          padding: '.5rem',
          background: '#555',
          color: '#fff',
          letterSpacing: '1px',
          maxWidth: "600px",
          overflow: 'auto'
        }}
      >
        <pre
          style={{
            fontSize: '.65rem',
            padding: '.25rem .5rem',
            overflowX: 'scroll',
          }}
        >{JSON.stringify(values, null, 2)}</pre>
      </div>
    </div>

  } else {
    return <></>
  }
}